import {setAnalyticsCollectionEnabled,setConsent} from "firebase/analytics"
import analytics from "../helpers/analytics"
import LinkedInTag from "react-linkedin-insight"

const useAnalyticsConsent=() => {
    const updateAnalyticsConsent=(consent) => {
        const consentValue=consent? "granted":"denied"
        setConsent({
            ad_storage: consentValue,
            analytics_storage: consentValue,
            personalization_storage: consentValue,
            security_storage: consentValue,
            functionality_storage: consentValue,
        })
        if(consent) {
            window.clarity('consent')
            window.fbq('consent','grant');
            LinkedInTag.init(6796737,'px',false)
        }
    }
    return {updateAnalyticsConsent}
}

export default useAnalyticsConsent